import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system/explore")({
  component: () => <Navigate to="/admin/design-system/explore" />,
});
